
import { Injectable } from '@angular/core';
import { ToraxHttp } from 'src/app/utils/custom-http.svc';

@Injectable()
export class DashboardLocatorDataService {
    private url = 'api/dashboardLocator';
    constructor(
        private toraxHttp: ToraxHttp

    ) { }

    get() {
      return this.toraxHttp.get(`${this.url}/locatorModel`);
  }

  ivrMonitorData(baseQuery: any) {
    return this.toraxHttp.post(`${this.url}/ivrMonitorData`, baseQuery);
  }


  globalMonitorData(baseQuery: any) {
    return this.toraxHttp.post(`${this.url}/globalMonitorData`, baseQuery);
  }

  centeralData(baseQuery: any) {
    return this.toraxHttp.post(`${this.url}/centeralData`, baseQuery);
  }
}
